import { render, staticRenderFns } from "./newtrend-mode.vue?vue&type=template&id=b5c81c2a&"
import script from "./newtrend-mode.vue?vue&type=script&lang=js&"
export * from "./newtrend-mode.vue?vue&type=script&lang=js&"
import style0 from "./newtrend-mode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports